import React, { useMemo, useRef, useState } from 'react';
import { Select, Spin } from 'antd';
// import debounce from 'lodash/debounce';

import { Form, AutoComplete } from "antd";
import {
  GetJobTemplateTitleInfo,
  GetPostAJobTitles,
} from "../../../pages/api/Employer/Employer";
import { createUseStyles } from 'react-jss';

const UIAutoComplete = ({
  source,
  FieldType,
  label,
  name,
  required,
  rules,
  onChange,
  validateStatus,
  hasFeedback,
  help,
  disabled,
  defaultValue,
  placeholder = "",
  option = [],
  onGetData,
  mode,
  AutoCompleteType,

}) => {
  const styles = useStyles();
  // function DebounceSelect({ fetchOptions, debounceTimeout = 800, ...props }) {
  //   const [fetching, setFetching] = useState(false);
  //   const [options, setOptions] = useState([]);
  //   const fetchRef = useRef(0);
  //   const debounceFetcher = useMemo(() => {
  //     const loadOptions = (value) => {
  //       fetchRef.current += 1;
  //       const fetchId = fetchRef.current;
  //       setOptions([]);
  //       setFetching(true);
  //       fetchOptions(value).then((newOptions) => {
  //         if (fetchId !== fetchRef.current) {
  //           // for fetch callback order
  //           return;
  //         }
  //         setOptions(newOptions);
  //         setFetching(false);
  //       });
  //     };
  //     return debounce(loadOptions, debounceTimeout);
  //   }, [fetchOptions, debounceTimeout]);
  //   return (
  //       <Select
  //           labelInValue
  //           filterOption={false}
  //           onSearch={debounceFetcher}
  //           notFoundContent={fetching ? <Spin size="small" /> : null}
  //           {...props}
  //           options={options}
  //       />
  //   );
  // }

  const [value, setValue] = useState([]);

  async function fetchUserList(username) {
    let response = await GetPostAJobTitles(username)
    const res = response?.Data.map((user) => ({
      label: `${user.DataFields.JobTitle}`,
      value: user.FieldId,
    }))
    // const postAJobTitles = response?.Data?.map((loc) => loc);

    return res;
  }

  return (
    <Form.Item
      label={label}
      name={name}
      required={required}
      rules={rules}
      hasFeedback={hasFeedback}
      help={help}
      validateStatus={validateStatus}
      initialValue={
        Array.isArray(defaultValue) ? defaultValue : defaultValue?.toString()
      }
    >
      <Select
        mode={source === "autocompleteTab" ? "tags" : "multiple"}
        showSearch
        onChange={onChange}
        disabled={disabled}
        placeholder={placeholder}
        allowClear
        filterOption={(val, option) =>
          option.children.toString().toLowerCase().indexOf(val.toLowerCase()) >=
          0
        }
        className={styles.customSelect}
      >
        {(option ?? []).map(([email, name]) => (
          <Select.Option key={email} value={email}>
            {name?.trim()}
          </Select.Option>
        ))}
      </Select>
    </Form.Item>
  );
};

export default UIAutoComplete
const useStyles = createUseStyles({
  customSelect : {
    height: "51px !important",
    overflowX: "scroll",
    '& .ant-select-selector': {
      height: "50px",
      fontSize: "16px",
      fontWeight: 500,
      display: "flex",
      alignItems: "center",
    },
    '& .ant-select-selection-item': {
      fontSize: "16px",
      fontWeight: 500,
    },
    '& .ant-select-selection-placeholder': {
      fontSize: "16px",
      fontWeight: 500,
    },
  }
});